export enum WidgetTemplate {
    Test = 0, Default = 1, Tickets = 2, Activity = 3
}

export const widgetTemplateOptions = [
    { value: WidgetTemplate.Default, label: 'Default' },
    { value: WidgetTemplate.Test, label: 'Test' },
    { value: WidgetTemplate.Tickets, label: 'Tickets' },
    { value: WidgetTemplate.Activity, label: 'Activity' },
]
